import {
  ClientService,
} from '@fitness-force/api';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';
import { Observable, BehaviorSubject, forkJoin } from 'rxjs';
import {
  PaymentMethod,
  TENANTSINTERFACE,
} from '@fitness-force/models';

import { DividerModule } from 'primeng/divider';
import { TimelineModule } from 'primeng/timeline';

import { TableModule } from 'primeng/table';
import {
  UntypedFormBuilder,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { SelectModule } from 'primeng/select';
import { AvatarModule } from 'primeng/avatar';
import { TagModule } from 'primeng/tag';
import { StyleClassModule } from 'primeng/styleclass';
import { ToastMessageService } from '@fitness-force/api';
import {
  BadRequestError,
  NotFoundError,
} from '@fitness-force/errors';
import {
  TranslateModule,
} from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';

import { InvoiceTabComponent } from './invoice-tab/invoice-tab.component';
import { PaymentTabComponent } from './payment-tab/payment-tab.component';
import { TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { DateTimeFormatPipe } from '@fitness-force/pipes/datetime-format';
import { SalesReturnComponent } from '@fitness-force/sales-return';
import { RefundListComponent } from '@fitness-force/refund';
import Statsig from 'statsig-js';


@Component({
  selector: 'transaction-tab',
  templateUrl: './transaction-tab.component.html',
  styleUrls: ['./transaction-tab.component.scss'],
  providers: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DividerModule,
    TimelineModule,
    TableModule,
    ButtonModule,
    RippleModule,
    SelectModule,
    AvatarModule,
    TagModule,
    StyleClassModule,
    DialogModule,
    DateTimeFormatPipe,
    InvoiceTabComponent,
    PaymentTabComponent,
    SalesReturnComponent,
    RefundListComponent,
    TranslateModule
]
})
export class TransactionTabComponent implements OnInit {
  getAccessTenantList$: Observable<any> | any | null;
  tenantId = 0;
  paymentStatus: any[] = [];
  invoicesPaidFullTableData: any[] = [];
  @Input('clientId') clientId = 0;
  paymentMethods$ = new BehaviorSubject<PaymentMethod[]>([]);
  showBulkActionBar = false;
  transactionEnable = false;
  showPopUpForNewCard = false;

  showoptions = false;
  showEmailToast = false;
  showVoidPaymentModal = false;

  tags: string[] | undefined;

  activeTab = 'Transaction';
  showSalesReturn=  new BehaviorSubject(false);
  showRefund= new BehaviorSubject(false);

  @Output('updateData') updateData: EventEmitter<boolean> = new EventEmitter();



  constructor(
    private store: Store,
    private activatedRouter: ActivatedRoute,
    private clientService: ClientService,
    private toastMessageService: ToastMessageService,
    private fb: UntypedFormBuilder
  ) {
    this.tags = ['New Member', 'High Value', 'Allergy'];
  }

  ngOnInit(): void {
    if(Statsig.checkGate("show_salesreturn")){
      this.showSalesReturn.next(true);
    }
    else{
      this.showSalesReturn.next(false);
    }

    if(Statsig.checkGate("show_refund")){
      this.showRefund.next(true);
    }
    else{
      this.showRefund.next(false);
    }
    this.componentInit();
  }
  componentInit() {
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      if (this.tenantId > 0) {
        this.store.dispatch({ type: 'ROUTER_GO' });
      }
    });
    this.getCLientDetails();
  }

  getCLientDetails() {
    this.clientId = this.activatedRouter.snapshot?.params['clientid'] ? this.activatedRouter?.snapshot?.params['clientid'] : this.clientId;

    const getClientDetails$ = forkJoin([
      this.clientService.getClientPaymentMethods(this.clientId)
  ]);

    getClientDetails$.subscribe({
      next: (res: any) => {
        this.paymentMethods$.next(res[0].items ? res[0].items : []);
      },
      error: (error) => {
        this.toastMessageService.showError(error);
      },
    });
  }



  formatDate(d: any) {
    const parseDate = `${d.getFullYear()}-${d.getMonth() > 9 ? d.getMonth() : d.getMonth() + 1
      }-${d.getDate()}`;
    return parseDate.toString();
  }



  handleEvent(e: any) {
    this.componentInit();
  }

  handleTabAction(event:{closePopup:boolean, reloadData:boolean})
  {
    if(event.reloadData)
      this.componentInit();
  }

  handleUpdateData(event:any)
  {
    if (event && event.action && event.action == 'updated') this.updateData.emit(true);
  }

  handleSelectAll(selection: any) {
    if (selection.checked) {
      this.showBulkActionBar = true;
    } else {
      this.showBulkActionBar = false;
    }
  }

  getExpirtDateError(expirtDate: string) {
    const expiry = new Date(expirtDate);
    const todayDate = new Date();
    const priorDate = new Date(new Date().setDate(expiry.getDate() - 30));
    return todayDate <= priorDate

  }
  shareLink(type: string) {
    // here will have api call for sms and email.
  }

  showPaymentMethod(event: boolean) {
    this.transactionEnable = event;
    this.getCLientDetails();
  }

}
